module.exports = __webpack_public_path__ + "static/media/icon-backward-15.207827c1.svg";